export class OptimizationRule {
  id: string;
  projectId: number;
  modelRunId: string;
  fileName: string;
  rules: any;
}
